import React, { useState } from 'react';
import {
    Button,
    Grid,
    Typography,
    Box,
    Paper,
    FormHelperText,
    CircularProgress
} from '@mui/material';

const ImageUploader = ({ onChange, onUpload, loading, helperText, error }) => {
    const [images, setImages] = useState([]);
    const [files, setFiles] = useState([]);
    const [err, setErr] = useState('');

    const handleImageChange = (event) => {
        const newFiles = Array.from(event.target.files);
        if (newFiles.length + images.length > 10) {
            setErr('Es können jeweils nur 10 Bilder ausgewählt werden. Bitte teilen Sie die Uploads in zwei Zyklen auf.');
            return;
        }
        setErr('');

        const imageUrls = newFiles.map(file => ({
            file,
            url: URL.createObjectURL(file)
        }));

        setImages(prev => [...prev, ...imageUrls]);
        setFiles(prev => [...prev, ...newFiles]);

        // Return files to parent for upload
        onChange([...files, ...newFiles]);

        event.target.value = null;
    };

    const handleRemoveImage = (index) => {
        const newImages = [...images];
        const newFiles = [...files];
        newImages.splice(index, 1);
        newFiles.splice(index, 1);
        setImages(newImages);
        setFiles(newFiles);

        onChange(newFiles);
    };

    const handleUploadClick = async () => {
        if (onUpload) {
            const success = await onUpload(files);
            if (success) {
                setImages([]);
                setFiles([]);
                onChange([]);
            }
        }
    };

    return (
        <Box
            sx={{
                position: 'relative',
                padding: 2,
                border: '1px dashed #ccc',
                borderRadius: 2,
                borderColor: error ? 'error.main' : 'default',
                textAlign: 'center',
            }}
        >
            {loading && (
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(255, 255, 255, 0.7)',
                        zIndex: 10,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: 2,
                    }}
                >
                    <CircularProgress />
                </Box>
            )}

            <Typography variant="h6" sx={{ marginBottom: 2 }}>
                Dokumentfotos hochladen
            </Typography>

            <input
                accept="image/*"
                style={{ display: 'none' }}
                id="file-input"
                type="file"
                multiple
                onChange={handleImageChange}
            />
            <label htmlFor="file-input">
                <Button variant="contained" component="span" sx={{ marginBottom: 2 }}>
                    Bilder auswählen
                </Button>
            </label>

            {images.length > 0 && (
                <Button
                    variant="contained"
                    color="success"
                    onClick={handleUploadClick}
                    disabled={loading}
                    sx={{ ml: 2, mb: 2 }}
                >
                    {loading ? 'Uploading...' : 'Upload'}
                </Button>
            )}

            <Grid container spacing={2} sx={{ marginTop: 2 }}>
                {images.map((imageObj, index) => (
                    <Grid item xs={4} sm={3} md={2} key={index}>
                        <Paper elevation={2} sx={{ position: 'relative' }}>
                            <img
                                src={imageObj.url}
                                alt={`Preview ${index}`}
                                style={{
                                    width: '100%',
                                    height: '60px',
                                    objectFit: 'cover',
                                    borderRadius: 8,
                                }}
                            />
                            <Button
                                variant="contained"
                                onClick={() => handleRemoveImage(index)}
                                sx={{
                                    position: 'absolute',
                                    top: 0,
                                    right: 0,
                                    backgroundColor: 'primary.main',
                                    color: 'white',
                                    borderRadius: 0,
                                    minWidth: 0,
                                    width: 24,
                                    height: 24,
                                    opacity: 0.5,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '1.2rem',
                                    '&:hover': {
                                        opacity: 0.7,
                                    },
                                }}
                            >
                                &times;
                            </Button>
                        </Paper>
                    </Grid>
                ))}
            </Grid>

            {err && (
                <FormHelperText error sx={{ marginTop: 1 }}>
                    {err}
                </FormHelperText>
            )}
            {helperText && (
                <FormHelperText error={error} sx={{ marginTop: 1 }}>
                    {helperText}
                </FormHelperText>
            )}
        </Box>
    );
};

export default ImageUploader;